export default {
  name: 'MainUserProfileCard',
  props: {
    avatarUrl: {
      type: String,
      default: ''
    },
    displayName: {
      type: String,
      default: ''
    },
    roleLabel: {
      type: String,
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    },
    pageCacheEnabled: {
      type: Boolean,
      default: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/main/components/UserProfileCard/index.js